import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import {
  GET_TYPE_NOTES,
  CREATE_TYPE_NOTES,
  UPDATE_TYPE_NOTES,
  DELETE_TYPE_NOTES,
} from "./actionType";

import {
  TypeNotesApiResponseSuccess,
  TypeNotesApiResponseError,
} from "./action";

import {
  getTypesNotes as getNotesType,
  createTypesNotes as createNotesType,
  updateTypesNotes as updateNotesType,
  deleteTypesNotes as deleteNotesType,
} from "../../helpers/backend_helper";
import { notifyError, notifySuccess } from "../../components/notify";

function* getTypesNotes() {
  try {
    const response = yield call(getNotesType);
    yield put(TypeNotesApiResponseSuccess(GET_TYPE_NOTES, response));
  } catch (error) {
    yield put(TypeNotesApiResponseError(GET_TYPE_NOTES, error));
  }
}

function* createTypesNotes(data) {
  try {
    const response = yield call(createNotesType, data.payload.data);
    yield put(TypeNotesApiResponseSuccess(CREATE_TYPE_NOTES, response));
    notifySuccess("Categoria adicionada com sucesso!");
  } catch (error) {
    yield put(TypeNotesApiResponseError(CREATE_TYPE_NOTES, error));
    notifyError("Erro ao adicionar categoria!");
  }
}

function* updateTypesNotes(data) {
  try {
    const response = yield call(updateNotesType, data.payload.data);
    yield put(TypeNotesApiResponseSuccess(UPDATE_TYPE_NOTES, response));
    notifySuccess("Categoria atualizada com sucesso!");
  } catch (error) {
    yield put(TypeNotesApiResponseError(UPDATE_TYPE_NOTES, error));
    notifyError("Erro ao deletar categoria!");
  }
}

function* deleteTypesNotes(data) {
  try {
    const response = yield call(deleteNotesType, data.payload.id);
    yield put(TypeNotesApiResponseSuccess(DELETE_TYPE_NOTES, response));
    notifySuccess("Categoria deletada com sucesso!");
  } catch (error) {
    yield put(TypeNotesApiResponseError(DELETE_TYPE_NOTES, error));
    notifyError("Erro ao deletar categoria!");
  }
}

export function* watchGetTypesNotes() {
  yield takeEvery(GET_TYPE_NOTES, getTypesNotes);
}

export function* watchCreateTypesNotes() {
  yield takeEvery(CREATE_TYPE_NOTES, createTypesNotes);
}

export function* watchUpdateTypesNotes() {
  yield takeEvery(UPDATE_TYPE_NOTES, updateTypesNotes);
}

export function* watchDeleteTypesNotes() {
  yield takeEvery(DELETE_TYPE_NOTES, deleteTypesNotes);
}

function* TypesNotesSaga() {
  yield all([fork(watchGetTypesNotes)]);
  yield all([fork(watchCreateTypesNotes)]);
  yield all([fork(watchUpdateTypesNotes)]);
  yield all([fork(watchDeleteTypesNotes)]);
}

export default TypesNotesSaga;
